import { useCallback, useContext } from 'react'

import { SelectContext } from './Select.context'
import type { Option, useSelectExternalReturn } from './Select.types'

export function useSelectExternal(): useSelectExternalReturn {
  const select =
    useContext(SelectContext) ||
    (() => {
      throw new Error('useSelect should be wrapped in a SelectContext')
    })()

  const isChecked = useCallback(
    function isChecked(option: Option) {
      const { checked } = select.getSelectableOption(option)
      return checked
    },
    [select]
  )

  return {
    query: select.query,
    getOption: select.getOption,
    isChecked,
  }
}
